import { router } from 'src';

import { NavigationService } from 'src/services/navigation-service';
import { setAccount } from 'src/state/account/account-slice';
import { selectAccounts, selectSelectedAccountIdx } from 'src/state/account/selectors';
import { resetRequestsForNewAccountActionCreator } from 'src/state/request/action-creators';
import { AppDispatch, RootState } from 'src/state/types';
import { DataLayerUtils } from 'src/utils/data-layer-utils';

export const selectAccountActionCreator =
  (accountIdx: number) => (dispatch: AppDispatch, getState: () => RootState) => {
    const rootState = getState();
    const selectedAccountIdx = selectSelectedAccountIdx(rootState);
    const accounts = selectAccounts(rootState);
    const partnerId = accounts[accountIdx].partnerId;

    if (selectedAccountIdx !== accountIdx) {
      dispatch(resetRequestsForNewAccountActionCreator());
      dispatch(setAccount(accountIdx));
    }

    router.navigate(NavigationService.CHOOSE_SERVICE_LOCATION);
    DataLayerUtils.setCustomerAccountDataLayer(accounts.length, partnerId);
  };
